<div class="auth-form-card">
  <div class="auth-form-header">
    <img
      src="/assets/logos/cyflare-one-logo-new-colors.png"
      alt="Cyflare One"
      class="auth-form-logo"
    />
    <h2>Sign In</h2>
  </div>

  <form
    [formGroup]="loginForm"
    (ngSubmit)="login()"
  >
    <div class="auth-form-field">
      <kendo-floatinglabel text="Your Email Address">
        <input
          kendoTextBox
          formControlName="email"
          class="form-control"
          type="email"
          (input)="onEmailInput($event)"
        />
      </kendo-floatinglabel>
    </div>

    <div class="auth-form-field">
      <kendo-floatinglabel text="Enter Your Password">
        <input
          kendoTextBox
          formControlName="password"
          type="password"
          class="form-control"
        />
      </kendo-floatinglabel>
    </div>

    <div class="auth-form-links">
      <button
        kendoButton
        fillMode="clear"
        type="button"
        (click)="forgot()"
      >
        Forgot Password?
      </button>
    </div>

    <div class="auth-form-submit">
      <button
        kendoButton
        class="cyflare-btn-primary cyflare-btn-lg cyflare-btn-block"
        type="submit"
        [disabled]="!loginForm.valid"
      >
        Sign in
      </button>
    </div>

    <div class="auth-form-footer">
      <span>Having trouble signing in?</span>
      <a
        href="mailto:support@cyflare.com"
        kendoButton
        fillMode="clear"
      >
        Contact Us
      </a>
    </div>
  </form>
</div>
